import React from 'react';
import PropTypes from 'prop-types';

/*
Could potentially be integrated with inputGroup,
except InputGroup uses Formik specifically and that
is not needed here.
*/

const TableSearchInputGroup = props => {
  const { onSearch } = props;
  let input;

  const handleSearch = e => {
    if (e.key === 'Enter') {
      onSearch(input.value);
    }
  };

  const handleChange = () => {
    onSearch(input.value);
  };

  return (
    <div className="form-group d-print-none">
      <label className="form-label" htmlFor="tableSearchInputGroup" />
      <div className="input-group">
        <input
          type="search"
          id="tableSearchInputGroup"
          name="tableSearchInputGroup"
          className="form-control"
          onKeyPress={e => handleSearch(e)}
          onChange={handleChange}
          placeholder="Search..."
          ref={n => { input = n; }}
          aria-label="Table Search"
          aria-describedby="tableSearchButton"
          autoComplete="off"
        />
        <div className="input-group-append">
          <button
            type="button"
            id="tableSearchButton"
            name="tableSearchButton"
            className="btn btn-primary"
            aria-label="Table Search Button"
          >
            <i className="fas fa-search" />
          </button>
        </div>
      </div>
    </div>
  );
};

TableSearchInputGroup.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default TableSearchInputGroup;
